/**
 * @description: 获取图片文件的宽高
 * @param file 图片文件对象
 * @returns Promise返回图片的宽高信息
 */
export const getImageDimensions = (file: File): Promise<{ width: number; height: number }> => {
    return new Promise((resolve, reject) => {
        if (!file.type.match('image.*')) {
            reject(new Error('请选择图片文件'));
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                resolve({
                    width: img.width,
                    height: img.height
                });
            };
            img.onerror = () => {
                reject(new Error('图片加载失败'));
            };
            img.src = e.target?.result as string;
        };
        reader.onerror = () => {
            reject(new Error('文件读取失败'));
        };
        reader.readAsDataURL(file);
    });
};